//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import md5 from 'md5'
import Model from '@/models/login'
export default {
    props: {
        detail: Object,
        callback: Function
    },
    data(){
        const oldPwdValid = (rule, value, callback) => {
            if(!(/^[a-zA-Z0-9_]+$/.test(value))){ 
                callback(new Error('密码只能包含数字、字母、下划线'))
            }else{
                callback()
            }
        }
        const newPwdValid = (rule, value, callback) => {
            if(value !== this.form.newPassword){ 
                callback(new Error('两次密码输入不一致'))
            }else{
                callback()
            }
        }
        return{
            visible: false,
            form: {
                uid: '',
                newPassword: '',
                newPassword2: '',
            },
            formLabelWidth: '120px',
            rules: {
                newPassword: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在6到20之间', trigger: 'blur' },
                    { validator: oldPwdValid, trigger: 'blur' }
                ],
                newPassword2: [
                    {  validator: newPwdValid,  trigger: 'blur'  }
                ]
            },
            pwdState: false
        }
    },
    methods: {
        submit() {
            this.$refs.editForm.validate((state) => {
                if(!state) return;
                let formData = {...this.form};
                formData.newPassword = md5(formData.newPassword);
                delete formData.newPassword2;
                this.updatePwd({
                	key: formData.newPassword,
                	id: this.detail.id
                })
            })
        },
        async updatePwd(formData) {
            let { data } = await Model.updatePwd(formData);
            if(data.success) {
                this.visible = false;
                this.callback && this.callback()
            }
        },
        open() {
            for(let key in this.form) this.form[key] = this.detail[key]?this.detail[key]:''
        },
        close() {
            this.$refs.editForm.clearValidate()
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/index/PwdBox.vue